import OurWorksStyle from "../Styles/OurWorks.styles";

import ImageO from '../images/HeroImage.jpeg';
import ImageT from '../images/HouseT.jpg';
import ImageTH from '../images/HouseTH.jpg';
import ImageF from '../images/HouseF.jpeg';
import ImageFI from '../images/HouseFI.jpeg';
import ImageS from '../images/HouseS.jpeg';
import ImageSE from '../images/HouseSE.jpeg';
import ImageE from '../images/HouseE.jpeg';
import ImageN from '../images/HouseN.jpeg';
import ImageTE from '../images/HouseTE.jpeg';
import ImageEL from '../images/HouseEL.jpeg';
import ImageTW from '../images/HouseTW.jpeg';
const OurWorks = _ => (
  <OurWorksStyle id="ow">
    <p>Made With Love</p>
    <div>
      <img src={ImageO} alt="" />
      <img src={ImageT} alt="" />
      <img src={ImageTH} alt="" />
      <img src={ImageF} alt="" />
      <img src={ImageFI} alt="" />
      <img src={ImageS} alt="" />
      <img src={ImageSE} alt="" />
      <img src={ImageE} alt="" />
      <img src={ImageN} alt="" />
      <img src={ImageTE} alt="" />
      <img src={ImageEL} alt="" />
      <img src={ImageTW} alt="" />
    </div>
  </OurWorksStyle>
);

export default (OurWorks);